export const ROLES = {
  Select: "Select",
  Developer: "Developer",
  EndUser: "EndUser",
  Manager: "Manager",
  Admin: "Admin",
};
